import { Injectable } from '@angular/core';
import { AngularFirestore,AngularFirestoreCollection,AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { item } from '../m/item';
import { session } from '../m/session';
import { count } from 'rxjs/operators';


import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ItemService {


  itemscollection:AngularFirestoreCollection<session>;
  itemscollectionars:AngularFirestoreCollection<item>;
  items:Observable<session[]>;
  itemsars:Observable<item[]>;
  itemDoc:AngularFirestoreDocument<session>;
  itemDocars:AngularFirestoreDocument<item>;

  constructor(public afs:AngularFirestore ) { 
    this.itemscollection = this.afs.collection('session');
    this.items = this.afs.collection('session').snapshotChanges().pipe(map(change => {
      return change.map(a=>{
        const data = a.payload.doc.data() as session;
        data.id = a.payload.doc.id;
        return data;
      })
    }));

    this.itemscollectionars = this.afs.collection('ars');
    this.itemsars = this.afs.collection('ars').snapshotChanges().pipe(map(changears => {
      return changears.map(ars=>{
        const zebi = ars.payload.doc.data() as item;
        zebi.id = ars.payload.doc.id;
        return zebi;
      })
    }));

  }


  getItem(){
    return this.items;
  }
  getItemars(){
    return this.itemsars;
  }
  additem(session:session){
    this.itemscollection.add(session);
  }
  delitems(session:session){
        this.itemDoc = this.afs.doc(`session/${session.id}`);
        this.itemDoc.delete();
  }
  updateitem(session:item){
    this.itemDoc = this.afs.doc(`ars/1`);
    this.itemDoc.update(session);
  }

}
